module.exports = __webpack_public_path__ + "static/media/table-tennis.6fde5702.svg";